// extracted by mini-css-extract-plugin
export var alt = "PageBanner-module--alt--11c74";
export var container = "PageBanner-module--container--f6485";
export var ctaContainer = "PageBanner-module--ctaContainer--96cfa";
export var customSticky = "PageBanner-module--customSticky--8c523";
export var description = "PageBanner-module--description--f5d1a";
export var desktopOnly = "PageBanner-module--desktopOnly--b2871";
export var imageWrapper = "PageBanner-module--imageWrapper--ebd11";
export var main = "PageBanner-module--main--6f01f";
export var messageWrapper = "PageBanner-module--messageWrapper--54f8f";
export var mobileOnly = "PageBanner-module--mobileOnly--b6373";
export var pageBannerWrapper = "PageBanner-module--pageBannerWrapper--a7200";
export var row = "PageBanner-module--row--ece46";
export var stickyContainer = "PageBanner-module--stickyContainer--5230b";
export var styledContainer = "PageBanner-module--styledContainer--bf692";
export var textLeft = "PageBanner-module--textLeft--1f16f";
export var title = "PageBanner-module--title--3efbe";
export var title1 = "PageBanner-module--title1--51ba0";
export var visuallyHidden = "PageBanner-module--visuallyHidden--93d65";